export enum CustomErrorEnum {
  InsufficientFunds = "insufficientFunds",
}
